import * as helper from "@/store/helpers";
import { defineStore } from 'pinia'


export const useEventsStore = defineStore('events', {
    state(){
        return {
            allEvents: [],
            allFilters: [],
            selectedDate: new Date(),
            date_start: new Date(1010, 2, 1, 1, 10),
            date_end: new Date(3010, 2, 1, 1, 10),
            chosenFilters: ['Конференция', 'Семинар', 'Журнал', 'Прочее'],
            dateIsSelected: false,
            calendarRef: null
        }
    },
    getters: {
        eventsDateFilters(state){
            function getDateForCompare(date){
                return date.getDate() + date.getMonth() * 100 + date.getFullYear() * 10000                
            }
            let return_events = []
            for (let event of state.allEvents){
                if (!(getDateForCompare(state.selectedDate) >= getDateForCompare(event.date_start)))
                    continue
                if (!(getDateForCompare(state.selectedDate) <= getDateForCompare(event.date_end)))
                    continue
                let filterIncludes = false
                for (let filter of event.filers){
                    if (this.chosenFilters.includes(filter.name)){
                        filterIncludes= true
                    }
                    if (!(this.chosenFilters.includes(filter.name)) && (this.chosenFilters.includes('Прочее'))){
                        filterIncludes= true
                    }
                }
                if (filterIncludes)
                    return_events.push(event)
            }
            return return_events
        },
        get_week_saturday(state){
            return (date) => {
                state
                // let day = date.getDay()
                let new_date = new Date(date)
                let day = date.getDay()
                if (day == 0)
                    return new_date
                new_date.setDate(date.getDate() - day + 7)
                return new_date
            }
        },
        get_week_monday(state){
            return (date) => {
                state
                let day = date.getDay()
                if (day == 0){
                    let new_date = new Date(date)
                    new_date.setDate(date.getDate() - 6)
                    return new_date
                } 
                if (day == 1)
                    return date
                let new_date = new Date(date)
                new_date.setDate(date.getDate() - day + 1)
                return new_date 
            }
        },
        eventsFilters(state){
            let return_events = []
            for (let event of state.allEvents){
                let filterIncludes = false
                for (let filter of event.filers){
                    if (this.chosenFilters.includes(filter.name)){
                        filterIncludes= true
                    }
                }
                if (filterIncludes)
                    return_events.push(event)
            }
            return return_events
        },
        getEventColor: (state) => {
            state
            return (event) => {
                for (let filter of event.filers){
                    if (filter.name == "Конференция")
                        return "#0635AC"
                    if (filter.name == "Семинар")
                        return "#F24956"
                    if (filter.name == "Журнал")
                        return "#00AA8A"
                }
                return "#AA0075"
            }
        },
    },
    actions: {
        async getAllEvents() {
            let data = {
                'date_start': this.date_start,
                'date_end': this.date_end,
                // Do not hard-limit by filter IDs on home slider:
                // we need all upcoming events to make arrows meaningful.
                'filters_id': []
            }
            let res = await helper.api('POST','/events', data)
            for (let event of res){
                event.date_start = new Date(event.date_start)
                event.date_end = new Date(event.date_end)
            }
            this.allEvents = res
        },
        setDefaultFilters(){
            this.chosenFilters = ['Конференция', 'Семинар', 'Журнал', 'Прочее']
        },
        setSelectedDate(newSelectedDate){
            this.selectedDate = newSelectedDate
        },
        setChosenFilters(newChosenFilters){
            this.chosenFilters = newChosenFilters
        },
        setNearestDateToSelectedDate(){
            let nearestDate = new Date()
            if (this.allEvents.length >0){
                nearestDate = this.allEvents[0].date_start
            }
            for (let event of this.allEvents){
                if (Math.abs(event.date_start - new Date()) < nearestDate){
                    nearestDate = event.date_start
                }
            }
            this.selectedDate = new Date(nearestDate)
        },
        setDateToThisMonth(){
            let nearestDate = new Date()
            
            let events = this.allEvents.filter((_event) => _event.date_start.getMonth() == nearestDate.getMonth() & _event.date_start.getFullYear() == nearestDate.getFullYear())
            if (events.length >0){
                nearestDate = events[0].date_start
            }
            for (let event of events){
                if (Math.abs(event.date_start - new Date()) < nearestDate){
                    nearestDate = event.date_start
                }
            }
            this.selectedDate = new Date(nearestDate)
        },
        setDateIsSelected(value){
            this.dateIsSelected = value
        },
        weekRight(){
            let _selectedDate = new Date()
            let _date = this.selectedDate.getDate()
            _selectedDate.setDate(_date + 7)
            let new_date = _selectedDate.getDate()
            let new_month = this.selectedDate.getMonth()
            if (new_date < _date)
                new_month +=1
            _selectedDate.setMonth(new_month)
            _selectedDate.setYear(this.selectedDate.getFullYear())
            this.selectedDate = _selectedDate
        },
        weekLeft(){
            let _selectedDate = new Date()
            let _date = this.selectedDate.getDate()
            _selectedDate.setDate(_date - 7)
            let new_date = _selectedDate.getDate()
            let new_month = this.selectedDate.getMonth()
            if (new_date > _date)
                new_month -=1
            _selectedDate.setMonth(new_month)
            _selectedDate.setYear(this.selectedDate.getFullYear())
            this.selectedDate = _selectedDate
        }
    }
})